/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.modals.confirm.controllers', [])

.controller('ConfirmModalController', ['$scope', '$uibModalInstance', '$sce', 'modalTitle', 'okText', 'modalMessage', function($scope, $uibModalInstance, $sce, modalTitle, okText, modalMessage) {

    $scope.confirmModal = {

      message: $sce.trustAsHtml(modalMessage || ''),
      title: modalTitle,
      saveText: okText,

      init: function() {},

      close: function() {
        $uibModalInstance.dismiss('cancel');
      },

      done: function() {
        $uibModalInstance.close('success');
      }

    };

    $scope.confirmModal.init();

}]);